export default __webpack_public_path__ + "static/quiz-callout-ad266aab284977bbfc00b88a24ccdd25.jpg";